import React from "react";
import { Link } from "react-router-dom";
import { PageHero, GoldButton, GhostGoldButton } from "@/components/ui-bits";

export default function NotFoundPage() {
  return (
    <PageHero
      eyebrow="404"
      title="That page wandered off."
      lead="The page you're looking for isn't here. Use the links below to get back on track."
    >
      <div className="flex flex-wrap gap-4">
        <GoldButton as={Link} to="/" data-testid="notfound-home-btn">
          Back to Home
        </GoldButton>
        <GhostGoldButton
          as={Link}
          to="/contact"
          data-testid="notfound-contact-btn"
        >
          Contact Us
        </GhostGoldButton>
      </div>
    </PageHero>
  );
}
